import {
  TEntityOverride,
  TEntityOverrideProp,
  TEntityOverrideView,
  TEntityView,
} from 'src/types'

const extendGlobalEntity = <T extends TEntityView>(
  entity: Readonly<TEntityOverride>,
  viewKey: T,
): TEntityOverrideView<T> => {
  const { global, list, create, edit, ...entityWithoutViews } = entity
  const { properties: overridenProperties = {}, ...restViewProperty } =
    entity?.[viewKey] ?? {}

  const mergedKeys = [
    ...new Set(
      Object.keys(global?.properties ?? {}).concat(
        Object.keys(overridenProperties),
      ),
    ),
  ]
  const mergedProperties: Record<string, TEntityOverrideProp> =
    mergedKeys.reduce((acc, key) => {
      const property = (acc[key] = {
        ...global?.properties?.[key],
        ...overridenProperties[key],
      }) as TEntityOverrideProp

      if (viewKey === 'create') {
        property.hidden ||= property.readOnly === true
      }
      return acc
    }, {})

  return {
    ...entityWithoutViews,
    ...global,
    ...restViewProperty,
    properties: mergedProperties,
  } as TEntityOverrideView<T>
}

export default extendGlobalEntity
